<script>
export default {
    name: 'ResourcePicture',
    inheritAttrs: false,
    props: {
        resourceName: String,
    },
    data() {
        return {
            imageFormats: [],
        };
    },
    methods: {
        replaceExtension(subject, ext) {
            return subject.slice(0, subject.lastIndexOf('.') + 1) + ext;
        },
    },
    computed: {
        format() {
            return this.resourceName.slice(this.resourceName.lastIndexOf('.') + 1);
        },
        sources() {
            if (!['png', 'jpg', 'jpeg'].includes(this.format)) return {};

            const sources = {};
            for (const format of this.imageFormats) {
                sources['image/' + format] = this.replaceExtension(this.resourceName, format);
            }

            return sources;
        },
    },
    created() {
        const metaImageFormats = document.querySelector('meta[name="vue-image-formats"]')
            .getAttribute('content');
        this.imageFormats = metaImageFormats.split(',');
    },
};
</script>

<template>
    <picture>
        <source v-for="(source, mime) in sources" :key="mime" :srcset="source" :type="mime">
        <img :src="resourceName" v-bind="$attrs">
    </picture>
</template>

<style scoped lang="scss">

</style>
